import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-printers',
    templateUrl: './printers.component.html',
    styleUrls: ['./printers.component.scss'],
    standalone: false
})
export class PrintersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
